/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import TableStatus from './TableStatus';
import TaskInResultResponse from './TaskInResultResponse';

/**
 * The GetTableAnnotationResponse model module.
 * @module model/GetTableAnnotationResponse
 * @version 2.8.0
 */
class GetTableAnnotationResponse {
    /**
     * Constructs a new <code>GetTableAnnotationResponse</code>.
     * @alias module:model/GetTableAnnotationResponse
     * @param id {String} 
     * @param name {String} 
     * @param path {String} 
     * @param status {module:model/TableStatus} 
     * @param creationDate {String} 
     * @param lastModificationDate {String} 
     * @param annotationTask {module:model/TaskInResultResponse} 
     */
    constructor(id, name, path, status, creationDate, lastModificationDate, annotationTask) { 
        
        GetTableAnnotationResponse.initialize(this, id, name, path, status, creationDate, lastModificationDate, annotationTask);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name, path, status, creationDate, lastModificationDate, annotationTask) { 
        obj['id'] = id;
        obj['name'] = name;
        obj['path'] = path;
        obj['status'] = status;
        obj['creationDate'] = creationDate;
        obj['lastModificationDate'] = lastModificationDate;
        obj['annotationTask'] = annotationTask;
    }

    /**
     * Constructs a <code>GetTableAnnotationResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GetTableAnnotationResponse} obj Optional instance to populate.
     * @return {module:model/GetTableAnnotationResponse} The populated <code>GetTableAnnotationResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetTableAnnotationResponse();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('path')) {
                obj['path'] = ApiClient.convertToType(data['path'], 'String');
            }
            if (data.hasOwnProperty('projectCollection')) {
                obj['projectCollection'] = ApiClient.convertToType(data['projectCollection'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = TableStatus.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('creationDate')) {
                obj['creationDate'] = ApiClient.convertToType(data['creationDate'], 'String');
            }
            if (data.hasOwnProperty('lastModificationDate')) {
                obj['lastModificationDate'] = ApiClient.convertToType(data['lastModificationDate'], 'String');
            }
            if (data.hasOwnProperty('annotationTask')) {
                obj['annotationTask'] = TaskInResultResponse.constructFromObject(data['annotationTask']);
            }
        }
        return obj;
    }


}

/**
 * @member {String} id
 */
GetTableAnnotationResponse.prototype['id'] = undefined;

/**
 * @member {String} name
 */
GetTableAnnotationResponse.prototype['name'] = undefined;

/**
 * @member {String} path
 */
GetTableAnnotationResponse.prototype['path'] = undefined;

/**
 * @member {String} projectCollection
 */
GetTableAnnotationResponse.prototype['projectCollection'] = undefined;

/**
 * @member {module:model/TableStatus} status
 */
GetTableAnnotationResponse.prototype['status'] = undefined;

/**
 * @member {String} creationDate
 */
GetTableAnnotationResponse.prototype['creationDate'] = undefined;

/**
 * @member {String} lastModificationDate
 */
GetTableAnnotationResponse.prototype['lastModificationDate'] = undefined;

/**
 * @member {module:model/TaskInResultResponse} annotationTask
 */
GetTableAnnotationResponse.prototype['annotationTask'] = undefined;






export default GetTableAnnotationResponse;

